import { getWsBasePath } from "../utils";
import {
  ChannelTypeEnum,
  FrontEndServiceType,
  SendContentType,
  ServiceType,
} from "../types";

export * from "./wecom";
export * from "./wechat";

export const WS_EXPIRED_TIME = 60000;

export const DAMSELFISH_TOKEN = "damselfish-token";

export const sendContentTypeCorrespondingText = {
  [SendContentType.IMAGE]: "图片",
  [SendContentType.VIDEO]: "视频",
  [SendContentType.FILE]: "文件",
  [SendContentType.LINK]: "链接",
  [SendContentType.MINI_PROGRAM]: "小程序",
  [SendContentType.BUSINESS_CARD]: "好友卡片",
  [SendContentType.MENTION]: "提及",
  [SendContentType.GIF]: "动画表情",
  [SendContentType.VIDEO_NUM]: "视频号",
} as Record<SendContentType, string>;

export const serviceTypes = {
  [ServiceType.HOOK]: FrontEndServiceType.PC,
  [ServiceType.IPAD]: FrontEndServiceType.IPAD,
  [ServiceType.WECHAT_PC]: FrontEndServiceType.PC,
  [ServiceType.AIKE]: FrontEndServiceType.AIKE,
};

export const channelTypeTextMap = {
  [ChannelTypeEnum.Wechat]: "微信",
  [ChannelTypeEnum.Wecom]: "企业微信",
  [ChannelTypeEnum.Email]: "邮件",
};

export const channelTypeOptions = [
  {
    label: "企业微信",
    value: ChannelTypeEnum.Wecom,
  },
  {
    label: "微信",
    value: ChannelTypeEnum.Wechat,
  },
  {
    label: "邮件",
    value: ChannelTypeEnum.Email,
  },
];
export const channelTypeCorrespondingText = {
  [ChannelTypeEnum.Wecom]: "企业微信",
  [ChannelTypeEnum.Wechat]: "微信",
  [ChannelTypeEnum.Email]: "邮件",
};

export const GLOBAL_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/global`;
